import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit/src/mapBuilders";
import { NoInfer } from "@reduxjs/toolkit/src/tsHelpers";
import { setUser } from "../../common/user";
import { betListService } from "../../../services/admin/betList.service";
import { setGeneralProgressHide, setGeneralProgressShow, setGeneralSnackbarState } from "../../common/ui";


export type payloadSportList = {
  playerId: string | number | undefined;
  payload: {
    betId?: string;
    betType?: string;
    betResult?: string;
    sportTypeKey?: string;
    dateFrom?: string;
    dateTo?: string;
    limit?: number | '';
    after?: string;
  }
};

export type columnsItem = {
  name: string;
  type: string;
  sort: boolean;
  match?: boolean;
};

export type listItem = {
  [key: string]: any;
};

export interface ITableData {
  items: listItem[];
  columns: columnsItem[];
  totalCount: number | string;
}

export type betListSliceState = {
  sport: {
    data: ITableData | null,
    error: any,
    isFetching: boolean,
  },
};

const initialState: betListSliceState = {
  sport: {
    data: null,
    error: null,
    isFetching: false,
  },
};

export const getSportListData: any = createAsyncThunk(
  'admin/betList/getSportListData',
  async (payload: payloadSportList, { rejectWithValue, dispatch }) => {
    dispatch(setGeneralProgressShow());
    try {
      const response = await betListService.getSportList(payload);
      const data = await response.json();

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        return rejectWithValue(data)
      }

      dispatch(setGeneralProgressHide());

      return data;
    } catch (error) {
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error)
    }
  }
);

export const transfersSlice = createSlice({
  name: 'betList',
  initialState: initialState,
  reducers: {
    clearSportListState(state) {
      state.sport.error = null;
      state.sport.isFetching = false;
      state.sport.data = null;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<betListSliceState>>) => {
    builder.addCase(getSportListData.pending, (state ) => {
      state.sport.isFetching = true;
      state.sport.error = null;
    });
    builder.addCase(getSportListData.fulfilled, (state , action) => {
      state.sport.error = null;
      state.sport.isFetching = false;

      const { payload, meta } = action;

      const hasAfter = action.meta?.arg?.payload.hasOwnProperty('after') && action.meta?.arg?.payload?.after

      if (hasAfter && state.sport.data) {
        state.sport.data.items = [
          ...(state.sport.data.items || []),
          ...(payload.items || []),
        ];
      } else {
        state.sport.data = action.payload;
      }
    });
    builder.addCase(getSportListData.rejected, (state , action) => {
      state.sport.isFetching = false;
      state.sport.error = action.payload;
      state.sport.data = null;
    });
  },
});
export const {
  clearSportListState,
} = transfersSlice.actions;
export default transfersSlice.reducer;
